<script>
import AppNavbar from '@/components/AppNavbar'
import ArticleCover from '@/components/ArticleCover'
import ArticleMore from '@/components/ArticleMore'
import shareMixin from '@/mixins/shares'

export default {
	name: 'Article6',
	components: {
		AppNavbar,
		ArticleCover,
		ArticleMore,
	},
	mixins: [shareMixin],
	head: {
		title: {
			inner: '100-й эпизод "Ходячих мертвецов"'
		},
		meta: [
			{p: 'og:title', c: 'Афиша Zombie: 100-й эпизод «Ходячих»'},
			{p: 'og:description', c: 'Где смотреть премьеру восьмого сезона в мире, где пока еще нет зомби?' },
			{p: 'og:image', c: '/static/share/6.jpg'},
			{p: 'og:site_name', c: 'Афиша Zombie'},
		]
	},
}
</script>



<template>
<div class="article">
	<app-navbar />
	<article-cover image="articles/6/cover.jpg">
		<h2 slot="title">100-й эпизод «Ходячих»:</h2>
		<p slot="text">Где его смотреть в мире, где пока еще нет зомби?</p>
	</article-cover>

	<section class="text start">
		<div class="inner">

			<h2>Юбилейная серия «Ходячих мертвецов», она же премьерная восьмого сезона. С чем к своеобразному празднику на костях подходят герои, что их ждет дальше и поможет ли в борьбе гигантская тигрица?</h2>

			<p>
				После седьмого сезона, более напоминавшего пусть и увлекательную, но все-таки шахматную партию, в которой герои тщательно расставлялись на доске грядущей битвы с головорезами Нигана, восьмой обещает вернуть былую лихость, столь ценимую фанатами зомби-тематики со всего мира.
				<br>
				О том, что битва предстоит предельно брутальная, говорит тот багаж, с которым герои подошли к восьмому сезону. Тысячи поверженных зомби — ничто в сравнении с огромными потерями среди живых. Мученические смерти близких (вспомним и в очередной раз содрогнемся от смертей Абрахама и Гленна, павших от ударов биты Нигана) наконец-то заставили Рика пересмотреть свою «мирную» политику и объявить о начале тотальной войны против Спасителей.

			</p>

			<img class="article-image" src="../assets/articles/6/1.jpg">

		</div>
	</section>

	<section class="text">
		<div class="inner">



			<p>
				Его основным бойцам тоже нечего терять. Карл, сын Рика, уже давно не юнец, а полноценный солдат в отряде. Дэрил, который испытывает горечь, оттого что считает себя виновным в смерти Гленна, может искупить свою вину только кровью Спасителей. Морган, мастер убивать при помощи заостренной палки, пересмотрел свои дзенские взгляды на мир и теперь тоже рвется в бой. Кэрол, материнский символ группы Рика, попыталась устраниться от окружающего ее кошмара, но, увы, ненадолго. Мишон, Тара, Розита и Мэгги — основной женский квартет сериала, тоже готовы пожертвовать многим, чтобы на этой части мировой карты установился хоть какой-то мир, пусть и в окружении орд голодных живых мертвецов.
			</p>

			<img class="article-image" src="../assets/articles/6/2.jpg">

		</div>
	</section>

	<section class="text">
		<div class="inner">

			<p>
				Смертельным оружием войск Королевства может стать и тигрица Шива, которая верой и правдой служит королю Иезекиилю. Не стоит забывать и про «перебежчика» Дуайта. Однако пока сложно определить его мотивы и на чьей он стороне.
			</p>
			<br>
			<p>
				Каким будет первый шаг в этой битве, можно узнать с 23 октября, когда на телеканале Fox состоится мировая премьера первого эпизода нового сезона «Ходячих мертвецов».
			</p>

		</div>
	</section>

	<section class="text footer">
		<div class="inner">
			Смотреть сериал можно в «Интерактивном ТВ Ростелеком».
			<br>
			Если нашествие зомби застало вас не дома, подключайте опцию «Мультискрин» —<br>с ней весь контент будет доступен не только на экране телевизора,<br>но и <a href="https://moscow.rt.ru/inttv" target="_blank" onclick="ga('send', 'event', 'link', 'article', 'rostelekom')">на сайте itv.rt.ru</a> или на вашем мобильном устройстве.
		</div>
	</section>

	<div class="footer-share clearfix">
		<div class="title">Поделиться статьей</div>
		<a :href="shareFb" target="_blank" @click="shareClick('fb')"><i class="fa fa-facebook" aria-hidden="true"></i></a>
		<a :href="shareVk" target="_blank" @click="shareClick('vk')"><i class="fa fa-vk" aria-hidden="true"></i></a>
		<a :href="shareTg" target="_blank" @click="shareClick('tg')"><i class="fa fa-telegram" aria-hidden="true"></i></a>
		<a :href="shareTw" target="_blank" @click="shareClick('tw')"><i class="fa fa-twitter" aria-hidden="true"></i></a>
		<a :href="shareOk" target="_blank" @click="shareClick('ok')"><i class="fa fa-odnoklassniki" aria-hidden="true"></i></a>
	</div>

	<div class="devider"></div>

	<section class="text more">
		<div class="inner">Читайте также</div>
	</section>

	<article-more :ids="[1, 2, 3]" />


</div>
</template>



<style lang="less" scoped>
@import "../styles/colors.less";
@import "../styles/fonts.less";

.article {
	background: #fff;
}

section {
	width: 96%;
	max-width: 1040px;
	margin: 0 auto;
}

section .inner {
	max-width: 740px;
}

section h2 {
	padding: 0;
	margin: 0;
	font-weight: normal;
	font-size: 20px;
	padding-bottom: 20px;
	line-height: 30px;
}

section h3 {
	padding: 0;
	margin: 0;
	font-family: @fontLava;
	font-size: 18px;
	font-weight: bold;
	line-height: 27px;
}

section p {
	padding: 0;
	margin: 0;
	font-family: @fontLava;
	font-size: 18px;
	font-weight: normal;
	line-height: 27px;
}

.start {
	padding-top: 40px;
}

.text {
	background: #fff;
}

.article-image {
	width: 100%;
	max-width: 740px;
	padding: 40px 0;
}

.footer {
	padding: 40px 0;
	font-weight: 400;
	font-style: italic;
	font-family: @fontLava;
	line-height: 27px;
	font-size: 18px;

	a {
		color: @red;
	}
}

.footer-share {
	width: 100%;
	max-width: 1040px;
	margin: 0 auto;

	.title {
		width: 260px;
		height: 60px;
		line-height: 60px;
		font-size: 13px;
		letter-spacing: 1.5px;
		text-align: center;
		text-transform: uppercase;
		color: #fff;
		background: @red;
		float: left;
	}

	a {
		width: 80px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		font-size: 20px;
		float: left;
		color: #fff;
		transition: opacity 200ms ease;
		background: #090909;
		transition: all 200ms ease;
		border-right: 1px solid #333333;
		box-sizing: border-box;
	}

	a:last-child {
		border-right: none;
	}

	a:hover {
		background: @red;
	}

}

.devider {
	width: 100%;
	height: 5px;
	background: #090909;
	margin-top: 60px;
}

.more {
	color: @red;
	font-size: 30px;
	height: 80px;
	line-height: 80px;
}






@media only screen
and (max-device-width: 640px),
only screen and (max-device-width: 736px),
only screen and (max-width: 480px) {


.footer-share {

	.title {
		display: none;
	}

	a {
		width: 20vw;
		height: 20vw;
		text-align: center;
		line-height: 20vw;
		font-size: 20px;
		float: left;
		color: #fff;
		transition: opacity 200ms ease;
		background: #090909;
		transition: all 200ms ease;
		border-right: 1px solid #333333;
		box-sizing: border-box;
	}

}

.devider {
	display: none;
}



}

</style>



// WEBPACK FOOTER //
// Article6.vue?ac2709da